// extracted by mini-css-extract-plugin
export var gif = "_kr-0";